export default{sources:{avif:"__VITE_ASSET__DuL2ybq7__ 512w",webp:"__VITE_ASSET__DHn6GA2k__ 512w"},img:{src:"__VITE_ASSET__DacSPZ0B__",w:512,h:512}};